import { TFunction } from 'i18next';

import { I18nNamespace } from '~/common/types';
import { ProgressIndicatorAlternatingProps } from '~/components/ProgressIndicator/ProgressIndicatorAlternating';

export const createProgressIndicatorAlternatingProps = (
  t: TFunction<I18nNamespace.intake, undefined>,
): ProgressIndicatorAlternatingProps => {
  return {
    messages: [t('processingStates.storing'), t('processingStates.wait')],
  };
};
